import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();

  const isActive = (path) => location.pathname === path;

  useEffect(() => {
    setIsMenuOpen(false);
  }, [location.pathname]);

  return (
    <header>
      <nav>
        <input
          type="checkbox"
          id="check"
          checked={isMenuOpen}
          onChange={() => setIsMenuOpen(!isMenuOpen)}
        />
        <label htmlFor="check" className="checkbtn">
          <img src={`${process.env.REACT_APP_API_URL || 'http://localhost:8000'}/uploads/navbaricon.png`} alt="" className="navbaricon" width="35px" />
        </label>
        <hr className="line" />
        <ul>
          <li><Link to="/" className={isActive('/') ? 'active' : ''}>HOME</Link></li>
          <li><Link to="/about" className={isActive('/about') ? 'active' : ''}>ABOUT US</Link></li>
          <li><Link to="/product" className={isActive('/product') ? 'active' : ''}>PRODUCT AND SERVICES</Link></li>
          <li><Link to="/news" className={isActive('/news') ? 'active' : ''}>NEWS AND EVENTS</Link></li>
          <li><Link to="/contact" className={isActive('/contact') ? 'active' : ''}>CONTACT US</Link></li>
          <li><Link to="/career" className={isActive('/career') ? 'active' : ''}>CAREER</Link></li>
        </ul>
      </nav>
    </header>
  );
};

export default Header;
